export const CRICK_HOST_LEGACY = 'crick.labstep.com';
export const UKDRI_HOST_LEGACY_PRODUCTION = 'ukdri.labstep.com';
export const UKDRI_HOST_LEGACY_STAGING = 'ukdri-staging.labstep.com';
